import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import linkState from 'linkstate';
import { route } from 'preact-router';
import { Text, Localizer, withText } from 'preact-i18n';
import Mousetrap from 'mousetrap';

import Logo from '../../components/logo';
import LogoCustomer from '../../components/logo/customer';
import Clock from '../../components/gui/clock';

import localUtil from '../../lib/util';
import reloadAppHelper from '../../lib/reloadApp';

import style from './style.css';

const initialState = {
    menu: {
		profile: false,
		main: false,
	},
	searchText: '',
};

const MAX_HEIGHT = '25px';


@withText(props => ({
    allVisitsTitle: <Text id='dyrejournal.all-visits-title'>All visits</Text>,
    reportsTitle: <Text id='dyrejournal.reports-title'>Reports</Text>,
    journalsTitle: <Text id='dyrejournal.journals-title'>Journals</Text>,
    searchTitle: <Text id='dyrejournal.search-title'>Search</Text>,
}))
@observer
class Navigation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
        };
    }

	toggleDarkmode = (e) => {
        const { appState } = this.props.stores;
		appState.toggleDarkmode();
	}

	reloadApp = () => {
		reloadAppHelper();
	}

	changeLanguage = (e) => {
		const lang = e.target.value;
		const { userStore } = this.props.stores;
		const { user } = userStore;
		userStore.setLanguage({ email: user.email, language: lang });
	}

	scrollToTop = () => {
		const {  refreshPage = () => {} } = this.props;
		const { appState } = this.props.stores;
		appState.appContainerScrollTop();
		refreshPage();
	}

	addContent = () => {
		const { appState } = this.props.stores;
        const { drawerHeightXSmall } = appState;
        appState.openDrawer('addContent', {
            height: drawerHeightXSmall,
        }, 1);
	}

    search = () => {
		const { appState } = this.props.stores;
        const { drawerHeightLarge } = appState;
        appState.openDrawerRight('search', {
            height: drawerHeightLarge,
			title: 'Search',
        }, 1);
	}

	editInstallation = () => {
		const { id } = this.props;
		const { appState } = this.props.stores;
		const { drawerHeightMedium } = appState;
		appState.openDrawer('editInstallation', {
			height: drawerHeightMedium,
			id,
			lookupArray: 'parts',
		}, 1);
	}

	inspectInstallation = () => {
		// const { id } = this.props;
		const { appState, installationStore } = this.props.stores;
		const { installation = {} } = installationStore || {};
		const { id, name } = installation;
		// console.log('inspectInstallation', id);
		const { drawerHeightLarge } = appState;
		appState.openDrawer('inspectInstallation', {
			title: `Inspect: ${name}`,
			height: drawerHeightLarge,
			id,
		}, 1);
	}

	userMenu = () => {
		const { appState, userStore } = this.props.stores;
		const { drawerHeightMedium } = appState;

		const { notifications = [] } = userStore;
		const unreadNotificatins = notifications.filter(e => !e.read);
		const unread = unreadNotificatins.length || 0;
        appState.openDrawer('menu', {
            height: drawerHeightMedium,
        }, 1);
	}

	gotoFrontpage = () => {
		route('/');
	}

	marketplace = () => {
		route('/article-list/');
	}

	gotoCart = () => {
		route('/cart/');
	}

	myProfile = () => {
		route('/users/profile');
	}

	goBack = () => {
		window.history.back();
	}

	goToPage = (url) => {
		route(url);
	}

	onClickNewSale = async e => {
		const { saleStore, appState } = this.props.stores;
        const { path } = appState;
        if (path.match(/^\/dyrejournal-sale\/\d+/)) {
            route(`/dyrejournal-sale`);
        }
        saleStore.createNewSale();
		await appState.checkVersion();
    }

	onClickAllVisits = e => {
		const { drawerLevel = 1, allVisitsTitle } = this.props;
		const { appState } = this.props.stores;

		appState.openDrawerRight('allVisits', {
            hideAdmin: false,
			title: allVisitsTitle,
		}, drawerLevel + 1);
	}

	onClickCalendar = e => {
		route('/calendar/');
	}

	onClickDyrejournal = e => {
		route('/dyrejournal-sale/');
	}

	onClickNotifications = e => {
		route('/calendar/notifications');
	}

	onClickReports = e => {
		const { drawerLevel = 1, reportsTitle } = this.props;
		const { appState } = this.props.stores;

		appState.openDrawerRight('reports', {
            hideAdmin: false,
			title: reportsTitle,
		}, drawerLevel + 1);
	}

	onClickJournals = e => {
		const { drawerLevel = 1, journalsTitle } = this.props;
		const { appState } = this.props.stores;

		appState.openDrawerRight('journals', {
            hideAdmin: false,
			title: journalsTitle,
		}, drawerLevel + 1);
	}

	onClickPhoneConsultation = e => {
		const { drawerLevel = 1 } = this.props;
		const { appState } = this.props.stores;

		appState.openDrawer('phoneConsultationNew', {
			height: appState.drawerHeightMediumLarge,
		}, drawerLevel + 1);
	}

	gotoInbox = () => {
		route('/users/profile/inbox');
	}

	openInbox = () => {
		const { drawerLevel = 1, reportsTitle } = this.props;
		const { appState } = this.props.stores;

		appState.openDrawerRight('inbox', {
		}, drawerLevel + 1);
	}

	openNotifications = () => {
		const { drawerLevel = 1 } = this.props;
		const { appState } = this.props.stores;

		appState.openDrawerRight('notifications', {
		}, drawerLevel + 1);
	}

	gotoSupport = () => {
		route('/support');
	}

	gotoSupportStaff = () => {
		route('/support/staff');
	}

	gotoContentCuration = () => {
		route('/admin/content-curation');
	}

	gotoModeration = () => {
		route('/admin/moderation');
	}

	openQuickSearch = () => {
		const { toggleQuickSearch } = this.props;
		if (toggleQuickSearch) {
			toggleQuickSearch();
		}
	}

	renderLeftButton = () => {
		const { appState, userStore, curatedContentStore, articleStore } = this.props.stores;
		const { user, isAdmin, isBlockedFromSupportTickets, isBlockedFromComments, customer } = userStore;
		const { isApproved, settings = {} } = user;
		const { backgroundColor } = settings;
        const { path, opts, isDevelopment } = appState;
        const userCustomerFlags = customer?.featureFlags || {};
		const { pendingCount = 0 } = curatedContentStore || {};
		const { moderationPendingCount = 0 } = articleStore || {};

		// Optional-product stores: absent from builds that exclude race/convention
		// modules — every destructure below coerces with || {}.
		const { raceStore, raceClassStore, conventionStore } = this.props.stores;

		const darkmode= util.getNestedValue(user, 'settings.darkmode');
		const linkTextClass = `${darkmode ? 'text-white' : 'text-dark'}`;
		const linkTextStyle = `line-height: 24px; font-size: 21px; font-weight: 400;`;
		if (path.match(/^\/installations/)) {
			return (<>
				<span onClick={this.openQuickSearch} class={`islink text-primary d-flex align-items-center ${linkTextClass} me-3`} style={`${linkTextStyle}`}>
					<i class={`fa-regular fa-magnifying-glass`} />
				</span>
				<span onClick={this.gotoFrontpage} class={`islink text-primary d-flex align-items-center ${linkTextClass}`} style={`${linkTextStyle}`}>
					<i class={`fa-regular fa-arrow-left`} /> <span class='d-none d-md-inline-block ms-1'><Text id='header.back'>Back</Text></span>
				</span>
			</>);
		}
		if (path.match(/^\/race\/\d+\/\d+\//)) {
			const { raceClass = {} } = raceClassStore || {};
			const { id } = raceClass;
			const { race = {} } = raceStore || {};
			const { id: raceId } = race;
			const url = id ? `/raceclass/${id}` : `/race/${raceId}`;
			return (<>
				<span onClick={() => url ? this.goToPage(url) : this.goBack()} class={`islink text-primary d-flex align-items-center ${linkTextClass}`} style={`${linkTextStyle}`} data-id={id}>
					{id ? <>
						<i class={`fa-regular fa-arrow-left`} /> <span class='d-none d-md-inline-block ms-1'><Text id='header.back-raceclass'>RaceClass</Text></span>
					</> : <>
						<i class={`fa-regular fa-arrow-left`} /> <span class='d-none d-md-inline-block ms-1'><Text id='header.back-race'>Race</Text></span>
					</>}
				</span>
			</>);
		}
		if (path.match(/^\/raceclass\/\d+$/)) {
			const { race = {} } = raceStore || {};
			const { id } = race;
			const url = id ? `/race/${id}` : '/race';
			return (<>
				<span onClick={() => url ? this.goToPage(url) : this.goBack()} class={`islink text-primary d-flex align-items-center ${linkTextClass}`} style={`${linkTextStyle}`}>
					<i class={`fa-regular fa-arrow-left`} /> <span class='d-none d-md-inline-block ms-1'><Text id='header.back-race'>Race</Text></span>
				</span>
			</>);
		}
		if (path.match(/^\/raceclass/)) {
			const { raceClass = {} } = raceClassStore || {};
			const { id } = raceClass;
			const url = id ? `/raceclass/${id}` : '/race';
			return (<>
				<span onClick={() => url ? this.goToPage(url) : this.goBack()} class={`islink text-primary d-flex align-items-center ${linkTextClass}`} style={`${linkTextStyle}`}>
					<i class={`fa-regular fa-arrow-left`} /> <span class='d-none d-md-inline-block ms-1'><Text id='header.back-raceclass'>RaceClass</Text></span>
				</span>
			</>);
		}
		if (path.match(/^\/race\/\d+$/)) {
			const url = `/`;
			return (<>
				<span onClick={() => url ? this.goToPage(url) : this.goBack()} class={`islink text-primary d-flex align-items-center ${linkTextClass}`} style={`${linkTextStyle}`}>
					<i class={`fa-regular fa-arrow-left`} /> <span class='d-none d-md-inline-block ms-1'><Text id='header.back-all-races'>All races</Text></span>
				</span>
			</>);
		}
		if (path.match(/^\/race\/\d+\//)) {
			const { race = {} } = raceStore || {};
			const { id } = race;
			const url = id ? `/race/${id}` : '/';

			return (<>
				<span onClick={() => url ? this.goToPage(url) : this.goBack()} class={`islink text-primary d-flex align-items-center ${linkTextClass}`} style={`${linkTextStyle}`}>
					<i class={`fa-regular fa-arrow-left`} /> <span class='d-none d-md-inline-block ms-1'><Text id='header.back-race'>Race</Text></span>
				</span>
			</>);
		}
		if (path.match(/^\/race\/$/)) {
			const url = `/`;
			return (<>
				<span onClick={() => url ? this.goToPage(url) : this.goBack()} class={`islink text-primary d-flex align-items-center ${linkTextClass}`} style={`${linkTextStyle}`}>
					<i class={`fa-regular fa-arrow-left`} /> <span class='d-none d-md-inline-block ms-1'><Text id='header.back-all-races'>All races</Text></span>
				</span>
			</>);
		}
		if (
			isApproved && (path.match(/^\/calendar/))
			|| path.match(/^\/dyrejournal-clinic/)
			|| path.match(/^\/dyrejournal-lab-results/)
			|| path.match(/^\/dyrejournal-payments/)
			|| path.match(/^\/dyrejournal-sms/)
			|| path.match(/^\/dyrejournal-mailsent/)
			|| path.match(/^\/dyrejournal-files/)
			|| path.match(/^\/dyrejournal-contacts/)
		) {
			if (opts.showDyrejournal || isDevelopment) {
				return (<>
					<span onClick={this.onClickDyrejournal} class={`islink text-primary ${linkTextClass}`} style={`${linkTextStyle}`}>
						<i class='fa-duotone fa-user-doctor-hair' /> <span class='d-none d-md-inline-block'><Text id='dyrejournal.frontpage'>Dyrejournal</Text></span>
					</span>
				</>);
			}
		}
		if (isApproved && path.match(/^\/dyrejournal-/)) {
			return (<>
				<span onClick={this.openQuickSearch} class={`islink text-primary d-flex align-items-center ${linkTextClass}`} style={`${linkTextStyle}`}>
					<i class={`fa-regular fa-magnifying-glass`} />
				</span>
				<span onClick={this.onClickAllVisits} class={`islink text-primary d-flex align-items-center ${linkTextClass} ms-3`} style={`${linkTextStyle}`}>
					<i class='fa-duotone fa-list' /> <span class='d-none d-md-inline-block ms-1'><Text id='dyrejournal.all-visits'>Visits</Text></span>
				</span>
				{!!userCustomerFlags.phoneConsultations && <span onClick={this.onClickPhoneConsultation} class={`islink text-primary d-flex align-items-center ${linkTextClass} ms-3`} style={`${linkTextStyle}`}>
					<i class='fa-duotone fa-phone-volume' /> <span class='d-none d-md-inline-block ms-1'><Text id='dyrejournal.phone'>Telefon</Text></span>
				</span>}
				<span onClick={this.onClickCalendar} class={`islink text-primary d-flex align-items-center ${linkTextClass} ms-3`} style={`${linkTextStyle}`}>
					<i class='fa-duotone fa-calendar' /> <span class='d-none d-md-inline-block ms-1'><Text id='dyrejournal.calendar'>Calendar</Text></span>
				</span>
				{/* <span onClick={this.onClickAllVisits} class={`islink text-primary ${linkTextClass} ms-3`} style={`${linkTextStyle}`}>
					<i class='fa-solid fa-gear' /> <span class='d-none d-md-inline-block ms-1'><Text id='dyrejournal.settings'>Settings</Text></span>
				</span> */}
			</>);
		}

		if (path.match(/^\/convention\/\d+\//)) {
			const { convention = {} } = conventionStore || {};
			const { id } = convention;
			const url = id ? `/convention/${id}` : '/convention/';
			return (<>
				<span onClick={() => url ? this.goToPage(url) : this.goBack()} class={`islink text-primary d-flex align-items-center ${linkTextClass}`} style={`${linkTextStyle}`}>
					<i class={`fa-regular fa-arrow-left`} /> <span class='d-none d-md-inline-block ms-1'><Text id='header.back'>Back</Text></span>
				</span>
			</>);
		}

		if (path.match(/^\/convention\/\d+/) || path.match(/^\/convention\/signup/)) {
			const url = `/convention/`;

			return (<>
				<span onClick={() => url ? this.goToPage(url) : this.goBack()} class={`islink text-primary d-flex align-items-center ${linkTextClass}`} style={`${linkTextStyle}`}>
					<i class={`fa-regular fa-arrow-left`} /> <span class='d-none d-md-inline-block ms-1'><Text id='header.back'>Back</Text></span>
				</span>
			</>);
		}

		if (path.match(/^\/musher-ranking/)) {
			const url = `/`;

			return (<>
				<span onClick={() => url ? this.goToPage(url) : this.goBack()} class={`islink text-primary d-flex align-items-center ${linkTextClass}`} style={`${linkTextStyle}`}>
					<i class={`fa-regular fa-arrow-left`} /> <span class='d-none d-md-inline-block ms-1'><Text id='header.back'>Back</Text></span>
				</span>
			</>);
		}

		if (path.match(/^\/course\/\d+/)) {
			const url = `/course`;

			return (<>
				<span onClick={() => this.goToPage(url)} class={`islink text-primary d-flex align-items-center ${linkTextClass}`} style={`${linkTextStyle}`}>
					<i class={`fa-regular fa-arrow-left`} /> <span class='d-none d-md-inline-block ms-1'><Text id='header.back'>Back</Text></span>
				</span>
			</>);
		}

		if (path.match(/^\/course\/?$/)) {
			const url = `/`;

			return (<>
				<span onClick={() => this.goToPage(url)} class={`islink text-primary d-flex align-items-center ${linkTextClass}`} style={`${linkTextStyle}`}>
					<i class={`fa-regular fa-arrow-left`} /> <span class='d-none d-md-inline-block ms-1'><Text id='header.back'>Back</Text></span>
				</span>
			</>);
		}

		const { supportTicketStore } = this.props.stores;
		const { unreadCount: supportUnread, openCount: supportOpen } = supportTicketStore;

		return (<>
			{isApproved && <>
				<span onClick={this.openQuickSearch} class={`islink text-primary d-flex align-items-center ${linkTextClass}`} style={`${linkTextStyle}`}>
					<i class={`fa-regular fa-magnifying-glass me-1`} />
				</span>
			</>}
			{user?.id && !isBlockedFromSupportTickets && <>
				<span onClick={this.gotoSupport} class={`islink text-primary d-flex align-items-center ${linkTextClass} position-relative`} style={`${linkTextStyle}`}>
					<i class='fa-duotone fa-life-ring ms-2 ms-md-3' />
					{supportUnread > 0 && <>
						<span class="position-absolute p-1 top-0 start-100 translate-middle badge rounded-pill bg-danger" style='z-index: 999999;'>
							{supportUnread}
							<span class="visually-hidden">unread support tickets</span>
						</span>
					</>}
					{(isAdmin || user?.isSupport) && supportOpen > 0 && <>
						<span class="position-absolute p-1 bottom-0 start-100 translate-middle badge rounded-pill bg-primary" style='z-index: 999999;'>
							{supportOpen}
							<span class="visually-hidden">open support tickets</span>
						</span>
					</>}
				</span>
			</>}
			{isAdmin && <>
				<span onClick={this.gotoContentCuration} class={`islink text-primary d-flex align-items-center ${linkTextClass} position-relative`} style={`${linkTextStyle}`}>
					<i class={`${path.match(/\/admin\/content-curation/) ? 'fa-solid fa-clipboard-check' : 'fa-regular fa-clipboard-check'} ms-2 ms-md-3`} />
					{pendingCount > 0 && <>
						<span class="position-absolute p-1 top-0 start-100 translate-middle badge rounded-pill bg-danger" style='z-index: 999999;'>
							{pendingCount}
							<span class="visually-hidden">pending reviews</span>
						</span>
					</>}
				</span>
				<span onClick={this.gotoModeration} class={`islink text-primary d-none d-md-flex align-items-center ${linkTextClass} position-relative`} style={`${linkTextStyle}`}>
					<i class={`${path.match(/\/admin\/moderation/) ? 'fa-solid fa-shield-halved' : 'fa-regular fa-shield-halved'} ms-2 ms-md-3`} />
					{moderationPendingCount > 0 && <>
						<span class="position-absolute p-1 top-0 start-100 translate-middle badge rounded-pill bg-danger" style='z-index: 999999;'>
							{moderationPendingCount}
							<span class="visually-hidden">pending moderation</span>
						</span>
					</>}
				</span>
			</>}
			{/* {path} */}
		</>);
	}

	// Basket icon. Lives in the LEFT column next to the back button: the right
	// column (profile/inbox/bell/menu) is already full on phones, and a fifth
	// icon there overflowed under the centred logo.
	renderCartButton = () => {
		const { userStore } = this.props.stores;
		const { user = {} } = userStore;
		const darkmode = util.getNestedValue(user, 'settings.darkmode');
		const linkTextClass = `${darkmode ? 'text-white' : 'text-dark'}`;
		const linkTextStyle = `line-height: 24px; font-size: 21px; font-weight: 400;`;
		const cartItems = (user.cart || []).filter(e => e.object?.type !== 'shipping');
		if (cartItems.length === 0) {
			return null;
		}
		const cartCount = cartItems.reduce((acc, e) => acc + (Number(e.qty) || 0), 0);
		return (
			<span onClick={this.gotoCart} class={`islink text-primary d-flex align-items-center ${linkTextClass} position-relative ms-2 ms-md-3 me-2`} style={`${linkTextStyle}`}>
				<i class='fa-duotone fa-cart-shopping' />
				<small class='position-absolute bg-danger text-white rounded-pill px-2' style='top: -15px; right: -15px;'>
					{cartCount}
				</small>
			</span>
		);
	}

	renderRightButton = () => {
		const { appState, userStore, saleStore, messageStore, supportTicketStore } = this.props.stores;
		const { user, isAdmin, isBlockedFromComments, notifications = [] } = userStore;
		// Grouped rows carry their own copy as grouped[0], so counting grouped children covers the row itself.
		const unreadNotifications = notifications.reduce((acc, n) => acc + (n.grouped?.length > 0 ? n.grouped.filter(e => !e.read).length : (n.read ? 0 : 1)), 0);
		const { isApproved, isSoknadsguideSuperAdmin } = user;
        const { path, opts = {} } = appState;
		const darkmode= util.getNestedValue(user, 'settings.darkmode');
		const linkTextClass = `${darkmode ? 'text-white' : 'text-dark'}`;
		const linkTextStyle = `line-height: 24px; font-size: 21px; font-weight: 400;`;

		const { unread } = messageStore;
		const { unreadCount: supportUnread, openCount: supportOpen } = supportTicketStore;
		const { newSale } = saleStore;
		const { visitors = [], animals = [], products = [] } = newSale;
		const isNewSale = visitors.length === 0 && animals.length === 0 && products.length === 0;

		if (path.match(/^\/installations/)) {
			return (<>
				{opts.showInspections && <span onClick={this.inspectInstallation} class={`islink text-primary d-flex align-items-center ${linkTextClass}`} style={`${linkTextStyle}`}>
					<i class={`fa-solid fa-user-magnifying-glass me-1`} />
				</span>}
				<span onClick={this.editInstallation} class={`islink text-primary d-flex align-items-center ${linkTextClass}`} style={`${linkTextStyle}`}>
					<i class={`fa-solid fa-pen ms-3 me-1`} />
				</span>
				{!isBlockedFromComments && <>
					<span onClick={this.openInbox} class={`islink text-primary d-flex align-items-center ${linkTextClass} position-relative`} style={`${linkTextStyle}`}>
						<i class='fa-duotone fa-inbox me-1 ms-3' />
						{unread > 0 && <>
							<span class="position-absolute p-1 top-0 start-100 translate-middle badge rounded-pill bg-danger" style='z-index: 999999;'>
								{unread}
								<span class="visually-hidden">unread messages</span>
							</span>
						</>}
					</span>
				</>}
				<span onClick={this.userMenu} class={`islink text-primary d-flex align-items-center ${linkTextClass}`} style={`${linkTextStyle}`}>
					<i class={`${path.match(/\/search/) ? 'fa-solid fa-bars' : 'fa-regular fa-bars'} me-1 ms-3`} />
				</span>
			</>);
		}

		if (isApproved && path.match(/^\/dyrejournal-sale/)) {
			return (<>
				{opts.showInspections && <span onClick={this.inspectInstallation} class={`islink text-primary d-flex align-items-center ${linkTextClass}`} style={`${linkTextStyle}`}>
					<i class={`fa-duotone fa-user-magnifying-glass me-1`} />
				</span>}

				{isNewSale ? <>
					<span onClick={this.onClickJournals} class={`islink text-primary d-flex align-items-center ${linkTextClass} me-3`} style={`${linkTextStyle}`}>
						<i class='fa-duotone fa-book' /> <span class='d-none d-md-inline-block ms-1'><Text id='dyrejournal.journals'>Journals</Text></span>
					</span>
					<span onClick={this.onClickReports} class={`islink text-primary d-flex align-items-center ${linkTextClass}`} style={`${linkTextStyle}`}>
						<i class='fa-duotone fa-file-chart-column' /> <span class='d-none d-md-inline-block ms-1'><Text id='dyrejournal.reports'>Reports</Text></span>
					</span>
				</> : <>
					<span onClick={this.onClickNewSale} class={`islink text-primary d-flex align-items-center ${linkTextClass}`} style={`${linkTextStyle}`}>
						<i class='fa-duotone fa-house' /> <span class='d-none d-md-inline-block ms-1'><Text id='dyrejournal.main-page'>Main page</Text></span>
					</span>
				</>}
				{!isBlockedFromComments && <>
					<span onClick={this.openInbox} class={`islink text-primary d-flex align-items-center ${linkTextClass} position-relative`} style={`${linkTextStyle}`}>
						<i class='fa-duotone fa-inbox me-1 ms-3' />
						{unread > 0 && <>
							<span class="position-absolute p-1 top-0 start-100 translate-middle badge rounded-pill bg-danger" style='z-index: 999999;'>
								{unread}
								<span class="visually-hidden">unread messages</span>
							</span>
						</>}
					</span>
				</>}
				<span onClick={this.gotoSupportStaff} class={`islink text-primary d-flex align-items-center ${linkTextClass} position-relative`} style={`${linkTextStyle}`}>
					<i class='fa-duotone fa-life-ring me-1 ms-3' />
					{supportUnread > 0 && <>
						<span class="position-absolute p-1 top-0 start-100 translate-middle badge rounded-pill bg-danger" style='z-index: 999999;'>
							{supportUnread}
							<span class="visually-hidden">unread support tickets</span>
						</span>
					</>}
					{(isAdmin || user?.isSupport) && supportOpen > 0 && <>
						<span class="position-absolute p-1 bottom-0 start-100 translate-middle badge rounded-pill bg-primary" style='z-index: 999999;'>
							{supportOpen}
							<span class="visually-hidden">open support tickets</span>
						</span>
					</>}
				</span>
				<span onClick={this.userMenu} class={`islink text-primary d-flex align-items-center ${linkTextClass}`} style={`${linkTextStyle}`}>
					<i class={`${path.match(/\/search/) ? 'fa-solid fa-bars' : 'fa-regular fa-bars'} me-1 ms-3`} />
				</span>
			</>);
		}

		if (isApproved && path.match(/^\/calendar\/notifications/)) {
			return (<>
				<span onClick={this.onClickCalendar} class={`islink text-primary d-flex align-items-center ${linkTextClass} ms-3`} style={`${linkTextStyle}`}>
					<i class='fa-duotone fa-calendar' /> <span class='d-none d-md-inline-block ms-1'><Text id='dyrejournal.calendar'>Calendar</Text></span>
				</span>
			</>);
		}
		if (isApproved && path.match(/^\/calendar/)) {
			return (<>
				<span onClick={this.onClickNotifications} class={`islink text-primary d-flex align-items-center ${linkTextClass}`} style={`${linkTextStyle}`}>
					<i class='fa-duotone fa-bell' /> <span class='d-none d-md-inline-block ms-1'><Text id='dyrejournal.calendar-notifications'>Notifications</Text></span>
				</span>
			</>);
		}

		return (<>
			{/* {isApproved && <>
				<span onClick={this.search} class={`islink text-primary d-flex align-items-center ${linkTextClass}`} style={`${linkTextStyle}`}>
					<i class={`${path.match(/\/search/) ? 'fa-solid fa-magnifying-glass' : 'fa-regular fa-magnifying-glass'} me-1 ms-3`} />
				</span>
			</>} */}
			{/* {(opts.showShooting || opts.showRace) && <>
				<span onClick={this.marketplace} class={`islink text-primary d-flex align-items-center ${linkTextClass}`} style={`${linkTextStyle}`}>
					<i class={`${path.match(/\/article-list/) ? 'fa-solid fa-box-dollar' : 'fa-regular fa-box-dollar'} me-1 ms-3`} />
				</span>
			</>} */}


			<span onClick={this.myProfile} class={`islink text-primary d-flex align-items-center ${linkTextClass}`} style={`${linkTextStyle}`}>
				<i class={`${path.match(/\/users\/profile/) ? 'fa-solid fa-user' : 'fa-regular fa-user'} me-1 ms-2 ms-md-3`} />
			</span>
			{user?.id && !isBlockedFromComments && <>
				<span onClick={this.openInbox} class={`islink text-primary d-flex align-items-center ${linkTextClass} position-relative`} style={`${linkTextStyle}`}>
					<i class='fa-duotone fa-inbox me-1 ms-2 ms-md-3' />
					{unread > 0 && <>
						<span class="position-absolute p-1 top-0 start-100 translate-middle badge rounded-pill bg-danger" style='z-index: 999999;'>
							{unread}
							<span class="visually-hidden">unread messages</span>
						</span>
					</>}
				</span>
			</>}
			{user?.id && <>
				<span onClick={this.openNotifications} class={`islink text-primary d-flex align-items-center ${linkTextClass} position-relative`} style={`${linkTextStyle}`}>
					<i class='fa-duotone fa-bell me-1 ms-2 ms-md-3' />
					{unreadNotifications > 0 && <>
						<span class="position-absolute p-1 top-0 start-100 translate-middle badge rounded-pill bg-danger" style='z-index: 999999;'>
							{unreadNotifications > 9 ? '9+' : unreadNotifications}
							<span class="visually-hidden">unread notifications</span>
						</span>
					</>}
				</span>
			</>}
			<span onClick={this.userMenu} class={`islink text-primary d-flex align-items-center ${linkTextClass}`} style={`${linkTextStyle}`}>
				<i class={`fa-regular fa-bars me-1 ms-2 ms-md-3`} />
			</span>
			{/* {path} */}
		</>);
	}

	componentDidMount() {
        Mousetrap.bind(['shift+m'], this.userMenu);
        Mousetrap.bind(['shift+i'], this.openInbox);
        Mousetrap.bind(['shift+s'], this.gotoSupport);
    }

    componentWillUnmount() {
        // Unbind shortcuts
        Mousetrap.unbind(['shift+m']);
        Mousetrap.unbind(['shift+s']);
        Mousetrap.unbind(['shift+i']);
    }

    render() {
		const { menu, searchText } = this.state;
		const { scrolledDown, refreshPage, clickOnLogo } = this.props;
        const { appState, userStore, raceStore } = this.props.stores;
        const { viewmode, path, opts = {}, isDevelopment, currentCustomer, isVisibleNavbar } = appState;
		const { allUsers, isAdmin, isCustomerAdmin, user, customer, notifications = [], currentEmail, simulatedEmail, simulatedCellphone, currentCustomers } = userStore;
		const { settings = {}, color: userColor } = user;
		const { backgroundColor } = settings;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

		const image = localUtil.getImage({ user, customer });
		const displayNameShort = localUtil.displayNameShort(user);
		const displayName = localUtil.displayName(user);

		const unreadNotificatins = notifications.filter(e => !e.read);
		const unread = unreadNotificatins.length || 0;
		const { language = 'en', toggleFeature = {} } = user;
		const linkTextClass = `${darkmode ? 'text-white' : 'text-dark'}`;
		const linkTextStyle = `line-height: 24px; font-size: 21px; font-weight: 400;`;

		// Find servername and display it
		const serverName = window.location.hostname;
		let version = serverName.match(/(dev)/) ? 'beta' : null;
		// version = serverName.match(/(localhost|127.0.0.1)/) ? 'dev' : null;

		const { race = {} } = raceStore || {};
        const { logo, logoHeight = 80, logoUrl, css } = race;
		const isRace = /^\/(race|raceclass)\/\d+/.test(path) && !/^\/(race|raceclass)\/\d+\/(tracking|admin\/dashboard)/.test(path); // tracking
		// http://localhost:8181/#/race/26/87/results
		// http://localhost:8181/#/race/26/results
		const isRaceResult = /^\/race\/\d+\/(\d+\/)?results/.test(path);
		const hasHeader = isRace && logo;
		const hasCustomerLogo = opts.showCustomerLogo && currentCustomer?.id && currentCustomer?.logoHeight;

		const hasChosenDepartment = user.currentCustomerDepartment;
		const department = customer?.departments?.find(dep => dep.id === hasChosenDepartment);

		return (<>
			{hasHeader ? <>
				<div
					class={`fixed-top w-100 d-flex flex-row justify-content-between ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} px-3 py-2 border-bottom`}
					style={`
						height: ${logoHeight}px;
						top: var(--native-safe-area-top, 0px);
						transform: ${isVisibleNavbar ? 'translateY(0)' : 'translateY(-100%)'};
						transition: transform 0.3s ease-in-out;
					`}
				>
					<div>
						<a href={logoUrl}>
							<img class='logoImg' src={logo} style={`max-height: ${logoHeight - 10}px;`} />
						</a>
					</div>
					{isRaceResult && <>
						<div class='d-flex justify-content-end align-items-center'>
							<Clock />
						</div>
					</>}
				</div>
			</> : <></>}

			<nav
				class={`navbar navbar-expand-xl navbar-themed ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} fixed-top py-0 px-3 ${scrolledDown > 0 ? style.scrolledDown : style.scrolledUp}`}
				style={`
					height: ${hasCustomerLogo ? currentCustomer?.logoHeight : '45px'};
					top: calc(${hasHeader ? logoHeight : 0}px + var(--native-safe-area-top, 0px));
					transform: ${isVisibleNavbar ? 'translateY(0)' : `translateY(${hasHeader ? '-300' : '-100'}%)`};
					transition: transform 0.3s ease-in-out;
					${(() => {
						// Use logged-in user's customer (from userStore), fallback to hostname-based customer (from appState)
						const activeCustomer = customer?.id ? customer : currentCustomer;
						const customerColor = activeCustomer?.color;
						// User color takes priority for background
						if (userColor) {
							// User has color - use as background
							// If customer also has color, use it for border-bottom
							const borderStyle = customerColor
								? `border-bottom: 3px solid ${customerColor};`
								: '';
							return `background-color: ${userColor} !important; ${borderStyle}`;
						}
						// No user color - fallback to customer color as background
						if (customerColor) {
							return `background-color: ${customerColor} !important;`;
						}
						return '';
					})()}
				`}
			>
				<div class='d-flex justify-content-between align-items-center w-100'>

					<div class={`${opts.showCustomerLogo ? 'w-25' : 'w-25'} d-flex justify-content-start align-items-center`}>
						{this.renderLeftButton()}
						{this.renderCartButton()}
					</div>

					<div class='flex-fill d-flex flex-row justify-content-center align-items-center'>
						{opts.showCustomerLogo ? <>
							{currentCustomer?.id && currentCustomer.logoHeight ? <>
								<LogoCustomer
									stores={this.props.stores}
									customerid={currentCustomer?.id}
									logoHeight={currentCustomer.logoHeight || '45px'}
									refreshPage={refreshPage}
									clickOnLogo={clickOnLogo}
								/>
							</> : <>
								<Logo
									darkmode={darkmode}
									stores={this.props.stores}
									style={'font-size: 1.2em;'}
									refreshPage={refreshPage}
									clickOnLogo={clickOnLogo}
								/>
								{version && <div
									class='position-absolute'
									style='
										top: 21px;
										left: calc(50% + 60px);
										font-size: 12px;
										color: red;
										font-weight: 700;
									'
								>
									{version}
								</div>}

							</>}
						</> : <>
							<Logo
								darkmode={darkmode}
								stores={this.props.stores}
								style={'font-size: 1.2em;'}
								refreshPage={refreshPage}
								clickOnLogo={clickOnLogo}
							/>
							{version && <div
								class='position-absolute'
								style='
									top: 21px;
									left: calc(50% + 60px);
									font-size: 12px;
									color: red;
									font-weight: 700;
								'
							>
								{version}
							</div>}
							{(opts.showDyrejournal || isDevelopment) ? <>
								<div class='d-none d-lg-block'>
									{customer.images && customer.images.length > 0 ? <img src={localUtil.displayImg(customer.images[0], this.props, '220x')} class='img-fluid' style='max-height: 30px;' /> : <></>}
								</div>
							</> : <></>}
						</>}
					</div>

					<div class='w-25 d-flex justify-content-end align-items-center'>
						{this.renderRightButton()}
					</div>

					{/* <div>
						<span class='mt-2 ms-4 position-relative' >
							<a href='/users/notifications' class={`islink text-primary ${linkTextClass}`} style={`${linkTextStyle}`}>
								<i class={`${path.match(/\/users\/notifications/) ? 'fa-solid fa-bell' : 'fa-regular fa-bell'} me-1`} />
								{unread > 0 && <>
									<span
										class='badge text-bg-danger position-absolute'
										style='font-size: 0.5em; right: -5px; top: -4px; padding: 2px 5px 3px;'
									>{unread > 9 ? '9+' : unread}</span>
								</>}
							</a>
						</span>
					</div> */}

				</div>

				{isAdmin && simulatedEmail ? <div class='position-absolute badge text-bg-danger' style='top: 0px; left: 25%;'>
					<button
						type='button'
						class='btn btn-link text-white p-0 text-decoration-none'
						style='font-size: inherit;'
						onClick={() => userStore.simulateCellphone('')}
						title='Click to end simulation'
					>
						<span class='font-weight-lighter'>Simulating:</span> {user.firstname} {user.lastname} ({simulatedEmail})
						<i class='fa-solid fa-times ms-2' />
					</button>
				</div> : <></>}

				{isAdmin && simulatedCellphone ? <div class='position-absolute badge text-bg-danger' style='top: 0px; left: 25%;'>
					<button
						type='button'
						class='btn btn-link text-white p-0 text-decoration-none'
						style='font-size: inherit;'
						onClick={() => userStore.simulateCellphone('')}
						title='Click to end simulation'
					>
						<span class='font-weight-lighter'>Simulating:</span> {user.firstname} {user.lastname} ({simulatedCellphone})
						<i class='fa-solid fa-times ms-2' />
					</button>
				</div> : <></>}

				{isCustomerAdmin || (currentCustomers && currentCustomers.length > 1) ? <>
					{currentCustomers && currentCustomers.length > 1 ? <>
						<div
							class='position-absolute d-flex flex-row text-bg-primary text-white rounded-pill px-3 py-0'
							style={`
								top: 0px;
								right: 2px;
								z-index: 1000;
								font-size: 0.6em;
								line-height: 1.0em;
							`}
						>
							<nobr>
								<span class='font-weight-normal'>
									{customer.name}
								</span>
								{hasChosenDepartment && <>
									<span class='font-weight-normal ms-1'>
										&raquo; {department ? `${department.id}: ${department.name}` : ''}
									</span>
								</>}
							</nobr>
						</div>
					</> : <>
						{hasChosenDepartment ? <>
							<div
								class='position-absolute badge text-bg-primary rounded-pill px-3 py-0'
								style={`
									top: 2px;
									right: 2px;
									z-index: 10000;
									font-size: 0.6em;
								`}
							>
								<span class='font-weight-normal'></span> {department ? `${department.id}: ${department.name}` : ''}
							</div>
						</> : <></>}
					</>}
				</> : <>
					{hasChosenDepartment ? <>
						<div
							class='position-absolute badge text-bg-primary rounded-pill px-3 py-0'
							style={`
								top: 2px;
								right: 2px;
								z-index: 10000;
								font-size: 0.6em;
							`}
						>
							<span class='font-weight-normal'></span> {department ? `${department.id}: ${department.name}` : ''}
						</div>
					</> : <></>}
				</>}

				{user.id ? <div class='position-absolute' style='top: 0px; left: 5px; font-size: 0.5em;'>
					<span class='font-weight-lighter'>Bruker: #{user.id}</span> {user.firstname} {user.lastname} / <span class='font-weight-lighter'>{user.cellphone}</span>
				</div> : <></>}

			</nav>
			{/* <xmp>{JSON.stringify(this.props, null, 2)}</xmp> */}
		</>);
	}
}

export default Navigation;
